"use client";

import { useState, useEffect } from "react";
import api, { mediaUrl } from "@/lib/api";

export interface News {
  id_noticia: string;
  nome_noticia: string;
  data_noticia: string;
  imagem_noticia: string;
  texto_noticia: string;
  codigo_noticia: string;
}

export interface NewsSimple {
  id_noticia: string;
  nome_noticia: string;
  data_noticia: string;
  imagem_noticia: string;
}

export function useNews() {
  const [newsList, setNewsList] = useState<NewsSimple[]>([]);

  const fetchNewsList = async () => {
    try {
      const response = await api.get("/noticias/");
      const data = response.data;

      const formattedNews: NewsSimple[] = data.map((news_data: { id_noticia: number; nome_noticia: string; data_noticia: string; imagem_noticia: string }) => ({
        id_noticia: news_data.id_noticia.toString(),
        nome_noticia: news_data.nome_noticia,
        data_noticia: news_data.data_noticia,
        imagem_noticia: mediaUrl(news_data.imagem_noticia),
      }));

      setNewsList(formattedNews);
    } catch (error) {
      console.error("Error fetching news list", error);
    }
  };

  const fetchNewsInfo = async (idNoticia: string | undefined) => {
    try {
      const response = await api.get(`/noticias/${idNoticia}/`);
      const data = response.data;

      const formattedNewsInfo: News = {
        id_noticia: data.id_noticia.toString(),
        nome_noticia: data.nome_noticia,
        data_noticia: data.data_noticia,
        imagem_noticia: mediaUrl(data.imagem_noticia),
        texto_noticia: data.texto_noticia,
        codigo_noticia: data.codigo_noticia,
      };
      return formattedNewsInfo;
    } catch (error) {
      console.error("Error fetching news info: ", error);
    }
  };

  useEffect(() => {
    fetchNewsList();
  }, []);

  return { newsList, fetchNewsList, fetchNewsInfo };
}

// Server-side fetch function for SSR
export async function fetchNewsServer(id: string): Promise<News | null> {
  try {
    const baseUrl = process.env.API_URL || process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000";
    const res = await fetch(`${baseUrl}/noticias/${id}/`, {
      cache: "no-store",
    });
    if (!res.ok) return null;
    const data = await res.json();

    return {
      id_noticia: data.id_noticia.toString(),
      nome_noticia: data.nome_noticia,
      data_noticia: data.data_noticia,
      imagem_noticia: mediaUrl(data.imagem_noticia),
      texto_noticia: data.texto_noticia,
      codigo_noticia: data.codigo_noticia,
    };
  } catch (error) {
    console.error("Error fetching news server-side:", error);
    return null;
  }
}
